<template lang="html">
   <div class="pass-code">
     <div class="title_bar">
         <span v-if="!forcePass">密码修改</span>
         <span v-else>首次登陆，请先重置您的密码！</span>
     </div>
     <div class="codeArea">

       <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
          <table>
              <tr>
                  <td class="textName">原始密码</td>
                  <td class="textInp">
                    <el-form-item prop="oldPwd">
                         <el-input v-model="ruleForm.oldPwd" type="password" placeholder="请输入初始密码" size="small"></el-input>
                    </el-form-item>

                  </td>
              </tr>
              <tr>
                  <td class="textName">新密码</td>
                  <td class="textInp">
                      <el-form-item prop="newPwd">
                           <el-input v-model="ruleForm.newPwd" placeholder="8-18 位数字 + 字母组合" type="password" size="small"></el-input>
                      </el-form-item>
                  </td>
              </tr>
              <tr>
                  <td class="textName">确认密码</td>
                  <td class="textInp">
                      <el-form-item prop="sureCode">
                           <el-input v-model="ruleForm.sureCode" placeholder="8-18 位数字 + 字母组合" type="password" size="small"></el-input>
                      </el-form-item>
                  </td>
              </tr>
              <tr>
                  <td class="textName"></td>
                  <td class="textInp text-btn">
                        <el-button type="primary" @click="submitForm('ruleForm')" size="small" :disabled="submiting">
                             <span>保存</span>
                             <i v-show="submiting" class="el-icon-loading"></i>
                        </el-button>
                  </td>
              </tr>
          </table>
        </el-form>

     </div>
   </div>
</template>

<script>

import { passCodeSet } from '@/api/login';
import { mapGetters } from 'vuex';
export default {
    props:['forcePass'],
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    data(){
        var passCode1 = (rule,val,callback) => {      // 邮编验证
             var pattern = /[0-9A-Za-z]{6,18}/;
             if(val == ''){
                callback(new Error('请输入原始密码！'));
             }else if(!pattern.test(val)){
                 callback(new Error('密码格式错误！'));
             }else{
                 callback();
             }
        };

        var passCode2 = (rule,val,callback) => {      // 邮编验证
             var pattern = /[0-9A-Za-z]{8,18}/;
             if(val == ''){
                 callback(new Error('请输入新密码！'));
             }else if(!pattern.test(val)){
                 callback(new Error('密码格式错误！'));
             }else if(val == this.ruleForm.oldPwd){
                 callback(new Error('新密码不能和旧密码相同！'));
             }else{
                 var ptn1 = /[0-9]+/ig;
                 var ptn2 = /[A-Za-z]+/ig;
                 var sure = ptn1.test(val) && ptn2.test(val);
                 if(sure){
                      callback();
                 }else {
                      callback(new Error('密码必须为数字和字母组合！'));
                 }
             }
        };

        var passCode3 = (rule,val,callback) => {      // 邮编验证
             var pattern = /[0-9A-Za-z]{8,18}/;
             if(this.ruleForm.newPwd == ''){
                callback(new Error('请先输入新密码！'));
             }else if(this.ruleForm.newPwd!=val){
                 callback(new Error('两次密码不一致'));
             }else{
                 callback();
             }
        };

        return{
            submiting:false,
            ruleForm:{
                 oldPwd:'',
                 newPwd:'',
                 sureCode:''
            },
            rules:{
                oldPwd:[{
                    validator: passCode1,
                    trigger: 'blur'
                }],
                newPwd:[{
                    validator: passCode2,
                    trigger: 'blur'
                }],
                sureCode:[{
                    validator: passCode3,
                    trigger: 'blur'
                }]
            }


        }
    },
    methods:{
      submitForm(formName) {
          var vues=this;
          console.log(vues.$store.getters.userInfo);
         this.$refs[formName].validate((valid) => {
           if (valid) {
              this.submiting = true;
              this.ruleForm.userId = this.userInfo.userId;
              passCodeSet({
                  oldPwd:md5(this.ruleForm.oldPwd),
                  newPwd:md5(this.ruleForm.newPwd),
                  userId:vues.$store.getters.userInfo.userId
              }).then(response=>{
                  this.submiting = false;
                  this.$alert("密码修改成功！","提示",{
                      confirmButtonText:"确定",
                      callback: action => {
                          vues.$store.dispatch('setOneLogin',1).then(res=>{
                            this.$emit("go-frash");
                        });
                      }
                  })
              })

           } else {
              return false;
           }
         });
       },
       resetForm(formName) {
         this.$refs[formName].resetFields();
       },
    }
}
</script>

<style lang="css">

.pass-code{
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #666666;
}

.pass-code .title_bar{
    height: 54px;
    padding-left: 3px;
    line-height: 54px;
    color:#666666;
    border-bottom: 1px solid #EFEFEF;
}

.pass-code .textName{
    width:240px;
    text-align: right;
}

.pass-code .textInp{
    padding-left: 12px;
    position: relative;
    text-align: left;
}

.pass-code .codeArea{
     margin-top: 30px;
}

.pass-code .codeArea td{
     padding-bottom: 12px;
}

.pass-code .el-input{
     width: 240px;
}

.pass-code .el-input input{
     border-radius: 0px;
     padding: 0px 12px;
}

.pass-code .el-form-item__error{
      width: 180px;
      position: absolute !important;
      left: 254px;
      top: 12px;
}

.pass-code .el-form-item{
   margin: 0px;
}

.pass-code .textInp .el-button{
     width: 120px;
     margin-top: 12px;
}

.pass-code .text-btn{
     text-align: center;
}

</style>



// WEBPACK FOOTER //
// passReset.vue?7ce400cc